import ApiUrlConstant from '../../../../Shared/Utils/UrlConstants';
import { axiosInstance } from '../../../../Interceptors/axiosInterceptor';

const Service = {
  getPatientList: (params = {}) => {
    // params = { page: 2 } etc.
    return axiosInstance.get(ApiUrlConstant.getPatientList(), {
      params, // ✅ this adds ?page=2 automatically
      loaderKey: 'get-patient', // optional custom config
    });
  },
  getOrderList: (id) => {
    return axiosInstance.get(ApiUrlConstant.getOrderList(id), { loaderKey: 'get-orderList' });
  },
  impersonatePatient: (patientId) => {
    return axiosInstance.post(ApiUrlConstant.adminImpersonate(), { target_user_id: patientId }, { loaderKey: 'impersonate-patient' });
  },
  suggestMedication: (patientId, payload) => {
    return axiosInstance.post(ApiUrlConstant.suggestMedication(patientId), payload, { loaderKey: 'suggest-medication' });
  },
  getSupplementProducts: () => {
    return axiosInstance.get(ApiUrlConstant.getSupplementProducts(), { loaderKey: 'get-supplement-products' });
  },
  syncSupplementProducts: () => {
    return axiosInstance.post(ApiUrlConstant.syncSupplementProducts(), {}, { loaderKey: 'sync-supplement-products' });
  },
  suggestSupplements: (patientId, payload) => {
    return axiosInstance.post(ApiUrlConstant.suggestSupplements(patientId), payload, { loaderKey: 'suggest-supplements' });
  },
  getPatientSupplementSuggestions: (patientId) => {
    return axiosInstance.get(ApiUrlConstant.getPatientSupplementSuggestions(patientId), { loaderKey: 'get-supplement-suggestions' });
  },
  getNextStepCards: (patientId) => {
    return axiosInstance.get(ApiUrlConstant.getNextStepCards(patientId));
  },
  setNextStepCards: (patientId, cards) => {
    return axiosInstance.post(ApiUrlConstant.setNextStepCards(patientId), { visible_cards: cards });
  },
  // Remove the admin override so the copy grid rules pick the cards again.
  resetNextStepCardsToRules: (patientId) => {
    return axiosInstance.post(ApiUrlConstant.setNextStepCards(patientId), { use_rules: true });
  },
  togglePortalLock: (patientId, portalLocked) => {
    return axiosInstance.post(ApiUrlConstant.togglePortalLock(patientId), { portal_locked: portalLocked });
  },
  getRegistrationUrl: (patientId) => {
    return axiosInstance.get(ApiUrlConstant.getRegistrationUrl(patientId));
  },
  getIntakeFormLink: (patientId) => {
    return axiosInstance.get(ApiUrlConstant.getIntakeFormLink(patientId));
  },
  getPatientJotformSubmissions: (patientId) => {
    return axiosInstance.get(ApiUrlConstant.getPatientJotformSubmissions(patientId));
  },
};

export default Service;
